
import emailjs from '@emailjs/browser';

// EmailJS Configuration
// To set this up:
// 1. Go to https://www.emailjs.com and create a free account
// 2. Add an Email Service (Gmail, Outlook, etc.) → copy the Service ID
// 3. Create an Email Template → copy the Template ID
// 4. Go to Account → API Keys → copy your Public Key
// 5. Replace the placeholder values below with your actual IDs

const EMAILJS_SERVICE_ID = 'YOUR_SERVICE_ID';
const EMAILJS_TEMPLATE_ID = 'YOUR_TEMPLATE_ID';
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';

export interface DonationEmailParams {
  donor_name: string;
  donor_email: string;
  donation_amount: string;
  payment_id: string;
  payment_type: string;
  donation_date: string;
  receipt_number: string;
  pan_number?: string;
}

export const sendDonationReceiptEmail = async (
  params: DonationEmailParams
): Promise<{ success: boolean; error?: string }> => {
  if (
    EMAILJS_SERVICE_ID === 'YOUR_SERVICE_ID' ||
    EMAILJS_TEMPLATE_ID === 'YOUR_TEMPLATE_ID' ||
    EMAILJS_PUBLIC_KEY === 'YOUR_PUBLIC_KEY'
  ) {
    console.warn('EmailJS is not configured yet. Please set up your EmailJS credentials in src/services/emailService.ts');
    return { success: false, error: 'Email service not configured' };
  }

  try {
    await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        to_name: params.donor_name,
        to_email: params.donor_email,
        donation_amount: params.donation_amount,
        payment_id: params.payment_id,
        payment_type: params.payment_type,
        donation_date: params.donation_date,
        receipt_number: params.receipt_number,
        pan_number: params.pan_number || 'Not provided',
        org_name: 'Diatomic Life Foundation',
        org_email: 'info@diatomiclife.org',
      },
      EMAILJS_PUBLIC_KEY
    );
    return { success: true };
  } catch (err: any) {
    console.error('EmailJS send error:', err);
    return { success: false, error: err?.text || 'Failed to send email' };
  }
};
